module.exports = __webpack_public_path__ + "img/9.6e39aa37.png";